import * as React from 'react';
import { useCallback } from 'react';
import { ThemeProvider, useTheme } from 'styled-components';
import { IEngineTheme } from './IEngineTheme';

export interface IEngineThemeProviderProps extends IEngineTheme {
  children: React.ReactNode;
}

/**
 * Permette di definire il tema (styled-components) delle componenti
 * in React interne a `engine`.
 * Da utilizzare in `web` per definire il tema.
 */
export function EngineThemeProvider(props: IEngineThemeProviderProps) {
  const addEngineTheme = useCallback(
    (theme: any) => {
      return {
        ...theme,
        // Aggiunge il tema dell'engine, mantenendo intatto il tema
        // esterno (web)
        engine: {
          accentColor: props.accentColor,
        },
      };
    },
    [props.accentColor],
  );

  return <ThemeProvider theme={addEngineTheme}>{props.children}</ThemeProvider>;
}

/**
 * Ottiene le opzioni del tema per l'engine
 */
export const useEngineTheme = () => {
  return useTheme()?.engine ?? {};
};
